/**
+ * JSON Schema for the playback Preferences.
+ *
+ * http://json-schema.org/
+ */
import defaults from "../constants";
const langCodes = ["off", ...defaults.supportedLanguages];
const playbackSchema = {
  id: "playbackSchema",
  type: "object",
  properties: {
    playback: {
      type: "object",
      required: true,
      properties: {
        audio: {
          type: "string",
          enum: langCodes
        },
        subtitles: {
          type: "string",
          enum: langCodes
        }
      },
      anyOf: [
        {
          required: ["audio"]
        },
        {
          required: ["subtitles"]
        }
      ]
    }
  }
};

export default playbackSchema;
